export default class SEPTAMetroPositionalSystem {
    static display_formats = {
        line_feet: "septametro",
    };

    static display_fields = {
        LINE: {
            name: "Line",
            rules: [{ required: true }],
        },
        FEET: {
            name: "Feet",
            rules: [{ required: true, type: "integer" }],
        },
        TRACK: {
            name: "Track",
            rules: [{}],
        },
    };

    fields(display_format) {
        return SEPTAMetroPositionalSystem.fields(display_format);
    }

    static fields(display_format) {
        return ["LINE", "TRACK", "FEET"];
    }

    displayFields(display_format) {
        return SEPTAMetroPositionalSystem.displayFields(display_format);
    }

    static displayFields(display_format) {
        return ["LINE", "TRACK", "FEET"];
    }

    field_value(field) {
        switch (field) {
            case "LINE":
                return this.line;
            case "FEET":
                return this.position;
            case "TRACK":
                return this.track;
            default:
                return null;
        }
    }

    static from_fields(system_id, display_format, fields) {
        const position = fields.FEET;
        return new SEPTAMetroPositionalSystem(system_id, fields.LINE, position, fields.TRACK);
    }

    static from_search(system_id, fields) {
        const position = parseInt(fields.paramTwo);
        return new SEPTAMetroPositionalSystem(system_id, fields.paramOne, position, null);
    }

    constructor(system_id, route, position, subposition, sources) {
        this.system = system_id;
        this.route = this.line = route;
        this.position = Math.round(position * 100);
        this.subposition = this.track = subposition;
        this.sources = sources;
        this.sign = position >= 0 ? 1 : -1;
    }

    to_string(display_format, isHorizontal) {
        let trackLabel = "Track ";
        if (isHorizontal) {
            trackLabel = "";
        }
        if (this.track !== null) {
            return `${this.line} ${trackLabel}${this.track} ${this.position.toString()}`;
        } else {
            return `${this.line} ${this.position.toString()}`;
        }
    }

    to_simple_string(display_format, remove_label) {
        if (remove_label) {
            return `${this.position.toString()}`;
        } else {
            return `${this.line} ${this.position.toString()}`;
        }
    }
}
